import ImprovementView from "./ImprovementView";

const ImprovementsView = ({ improvements }) => {
  return (
    <div className="mt-4">
      {improvements.length > 0 ? (
        <>
          <h5>Supplier Improvements</h5>
          <div className="mt-2 space-y-4">
            {improvements.map(({ node }, index) => (
              <ImprovementView key={index} improvement={node} />
            ))}
          </div>
        </>
      ) : (
        <div className="opacity-70 text-red-600 font-semibold">
          Supplier has not submit any improvement yet.
        </div>
      )}
    </div>
  );
};

export default ImprovementsView;
